module.exports = __webpack_public_path__ + "static/media/fanFoodLogo.814d7da6.png";